import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";

import ShowCalendar from '@/pages/Appointment/ShowCalendar';

import AddEditProfile from "@/pages/User/AddEditProfile.vue";
import ShowUser from "@/pages/User/ShowUser";
import AddEditUser from '@/pages/User/AddEditUser';

import ShowEmployee from '@/pages/Employee/ShowEmployee';
import AddEditEmployee from '@/pages/Employee/AddEditEmployee';

import ShowClient from '@/pages/Client/ShowClient';
import AddEditClient from '@/pages/Client/AddEditClient';

import Search from '@/pages/Report/Search';
import Daily from '@/pages/Report/Daily';

import ShowLogin from '@/pages/Login/ShowLogin';

const routes = [
	{
		path: "/",
		component: DashboardLayout,
		redirect: "/login",
		children: [
			{
				path: "dashboard/:id_employee?/:date?",
				name: "dashboard",
				component: Dashboard,
				meta: {
					requiresAuth:true
				}
			},
			{
				path:"calendar",
				name:"calendar",
				component:ShowCalendar,
				meta:{
					requiresAuth:true
				}
			},
			{
				path:"search",
				name:"search",
				component:Search,
				meta:{
					requiresAuth:true
				}
			},
			{
				path:'daily-report',
				name:"daily report",
				component:Daily,
				meta:{
					requiresAuth:true
				}
			},
			{
				path: "profile",
				name: "profile",
				component: AddEditProfile,
				meta: {
					requiresAuth:true
				}
			},
			{
				path: 'employees',
				name: 'employees',
				component: ShowEmployee,
				meta:{
					requiresAuth:true
				}
			},
			{
				path: 'employees/:id_employee',
				name: 'employees',
				component: AddEditEmployee,
				meta:{
					requiresAuth:true
				}
			},
			{
				path: 'clients',
				name: 'clients',
				component: ShowClient,
				meta:{
					requiresAuth:true
				}
			},
			{
				path: 'clients/:id_client',
				name: 'clients',
				component: AddEditClient,
				meta:{
					requiresAuth:true
				}
			},
			{
				path: "users",
				name: "users",
				component: ShowUser,
				meta: {
					requiresAuth:true,
					requiresAdmin:true
				}
			},
			{
				path: "users/:id_user",
				name: "users",
				component: AddEditUser,
				meta: {
					requiresAuth:true,
					requiresAdmin:true
				}
			},
			{
				path: 'login',
				name:'login',
				component: ShowLogin
			}
		]
	},
	{ path: "*", name:'not found',component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
	 var res= require('../components/Dashboard/Views/' + name + '.vue');
	 return res;
};**/

export default routes;
